import type { CreateEventInput, Event } from "@mvk/shared";
import { isApiEnabled } from "../api/config";
import { apiRequest } from "../api/client";
import { adminEventsApi } from "./adminEventsApi";

export const adminEventsService = {
  async list(): Promise<Event[]> {
    if (!isApiEnabled()) return [];
    const data = await apiRequest<{ events: Event[] }>("/events", {
      audience: "admin",
    });
    return data.events;
  },

  async getById(id: string): Promise<Event | null> {
    if (!isApiEnabled()) return null;
    const data = await adminEventsApi.getEvent(id);
    return data.event;
  },

  async create(input: CreateEventInput): Promise<Event> {
    const data = await apiRequest<{ event: Event }>("/events", {
      method: "POST",
      body: input,
      audience: "admin",
    });
    return data.event;
  },

  async update(id: string, patch: Partial<CreateEventInput>): Promise<Event> {
    const data = await adminEventsApi.updateEvent(id, patch);
    return data.event;
  },
};

export async function tryAdminEventsList(): Promise<Event[] | null> {
  if (!isApiEnabled()) return null;
  return adminEventsService.list();
}

export async function tryAdminEventById(id: string): Promise<Event | null> {
  if (!isApiEnabled()) return null;
  return adminEventsService.getById(id);
}
